<template>
  <div class="SlbDetail">
    <div class="SlbDetail-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/network/slbMonitor">{{
          $t("alarms.network.loadBalancing.loadBalancing")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Row type="flex" justify="space-between" class="code-row-bg">
      <Col span="6">
        <Card style="height: 480px">
          <Row>
            <Row style="height: 240px">
              <Col
                span="24"
                style="
                  text-align: center;
                  font-size: 103px;
                  display: block;
                  margin-top: 8px;
                "
              >
                <Icon type="ios-photos-outline" />
              </Col>
              <Col style="text-align: center; font-size: 18px">{{
                this.$route.query.name
              }}</Col>
            </Row>

            <Row style="margin-bottom: 20px">
              <Col>{{
                $t("alarms.network.loadBalancing.loadBalancingDescription")
              }}</Col>
              <Col>---</Col>
            </Row>
            <Row>
              <Col style="margin-bottom: 8px">{{
                $t("alarms.network.loadBalancing.loadBalancingConfiguration")
              }}</Col>
              <Row>
                <Col span="12"
                  >{{ $t("alarms.network.loadBalancing.name") }}:</Col
                >
                <Col span="10">{{ loadbalancerName }}</Col>
              </Row>
              <Row>
                <Col span="12"
                  >{{ $t("alarms.network.loadBalancing.region") }}:</Col
                >
                <Col span="10">{{ this.$route.query.region }}</Col>
              </Row>
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="13">
        <Card style="height: 480px">
          <ul class="content">
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-laptop"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{
                        $t(
                          "alarms.network.loadBalancing.configurationInformation"
                        )
                      }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>VPC ID：</li>
                            <li>{{ vpcId }}</li>
                          </ul>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-pulse"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.monitorMessage") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.monitorItems") }}：</li>
                            <li>
                              {{ monitoringNum }}
                              {{ $t("alarms.common.count") }}
                            </li>
                          </ul>
                        </Col>
                        <Col>
                          <a
                            @click="monitorMQ"
                            v-show="isNeedShowMonitoringOverview"
                            >{{ $t("alarms.common.viewMonitoringOverview") }}</a
                          >
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-medkit-outline"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.alertRule") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.alertRule") }}：</li>
                            <li>{{ priorityNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.untreated") }}：</li>
                            <li>{{ statusNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <a @click="alertRule">{{
                            $t("alarms.common.viewAlarmRules")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
          </ul>
        </Card>
      </Col>
      <Col span="4">
        <Card style="height: 480px">
          <Row>
            <Row style="margin-bottom: 10px">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
            <Row>
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import utils from "../../../../utils/utils.js";
export default {
  name: "SlbDetail",
  data() {
    return {
      isNeedShowMonitoringOverview: false,
      loadbalancerType: "",
      id: "",
      accountId: "",
      loadbalancerId: "",
      region: "",
      vpcId: "",
      tagList: [],
      name: "",
      accountTypeName: "",
      accountName: "",
      address: "",
      priorityNum: "",
      statusNum: "",
      monitoringNum: "",
      loadbalancerName: "",
      loadBalancerArn: "",
      monitorModule: "",
    };
  },
  mounted() {
    this.init();
    this.getLoadBalancerDetails();
  },
  methods: {
    init: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.loadbalancerId = this.$route.query.loadbalancerId;
      this.region = this.$route.query.region;
      this.accountName = this.$route.query.accountName;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.name = this.$route.query.name;
      this.loadbalancerType = this.$route.query.loadbalancerType;
      this.loadBalancerArn = this.$route.query.loadBalancerArn;
      this.monitorModule = this.$route.query.monitorModule;
    },
    // 通过loadbalancerId查询实例
    getLoadBalancerDetails: function () {
      var loadBalancerDetailsData = {
        loadbalancerName: this.$route.query.name,
        accountId: this.$route.query.accountId,
        loadbalancerId: this.$route.query.loadbalancerId,
        monitorModule: this.$route.query.monitorModule,
      };

      this.$api.loadBalancer
        .getLoadBalancerDetails(loadBalancerDetailsData)
        .then((res) => {
          this.loadbalancerName = res.data.loadbalancerName;
          this.priorityNum = res.data.priorityNum;
          this.statusNum = res.data.statusNum;
          this.monitoringNum = res.data.monitoringNum;
          this.vpcId = res.data.loadBalancerDTO.vpcId;
        });

      // 修改"查看监控概览" 是否可见标签，当前只完成阿里云的监控
      if (this.accountTypeName == "Aliyun" || this.accountTypeName == "GCP" || this.accountTypeName == "Tencent Cloud") {
        this.isNeedShowMonitoringOverview = true;
      } else {
        this.isNeedShowMonitoringOverview = false;
      }
    },

    // 点击查看监控概览
    monitorMQ: function () {
      this.$router.push({
        path: "/network/slb/",
        query: {
          id: this.id,
          accountId: this.accountId,
          loadbalancerId: this.loadbalancerId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
          loadbalancerType: this.loadbalancerType,
          loadBalancerArn: this.loadBalancerArn,
          monitorModule: this.monitorModule,
        },
      });
    },
    // 点击查看报警规则
    alertRule: function () {
      this.$router.push({
        path: "/network/slbWarning/",
        query: {
          id: this.id,
          accountId: this.accountId,
          loadbalancerId: this.loadbalancerId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
          loadbalancerType: this.loadbalancerType,
          loadBalancerArn: this.loadBalancerArn,
          monitorModule: this.monitorModule,
        },
      });
    },
  },
};
</script>

<style scoped>
.SlbDetail-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.host ul {
  list-style: none;
  overflow: hidden;
}
.host ul li {
  float: left;
}
.content > li {
  margin-bottom: 6px;
  border-bottom: 1px dashed #ccc;
  padding: 12px;
}
.content > li:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/slb/SlbDetail.vue